import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compareFechaActualFechaFija, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';

import SinResultadosPorFecha from '../../../../assets/images/SinResultadosFecha.png';

import * as actions from '../../../../store/actions/index';
import TextChart from '../../../Charts/TextChart';

const TextoChequesEnCartera = (props) => {
  const isDisabledChart = (props.estaOculto && !props.empresa) || !compareFechaActualFechaFija();

  useEffect(() => {
    if (
      !props.estaCargado &&
      !props.empresa &&
      !props.estaOculto &&
      compareFechaActualFechaFija() &&
      props.ejecucionDePagina
    ) {
      props.onLoadChart();
    }
    if (props.empresa) {
      props.onLoadChart(props.empresa.id);
    }

    return () => {
      if (props.empresa) {
        props.onUnmountChart();
      }
    };
  }, [props.ejecucionDePagina]);

  return (
    <TextChart
      title={`Cheques en cartera ${props.empresa ? props.empresa.nombre : ''} al ${fechaFinPeriodoMesActualFunc()}`}
      bigAmount={props.monto}
      bigAmountTooltip=""
      smallAmount={`${props.promedioDias}`}
      smallAmountTooltip="Prom. días de vencimiento"
      disabled={isDisabledChart}
      customDisabledImage={!compareFechaActualFechaFija() && !props.estaOculto ? SinResultadosPorFecha : undefined}
      bigCurrency
      cursorPointer={!isDisabledChart}
      loading={props.loading}
      onBodyClick={() => props.onBodyClick()}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.ventas.textoChequesEnCartera.loading,
    monto: state.ventas.textoChequesEnCartera.monto,
    promedioDias: state.ventas.textoChequesEnCartera.promedioDias,
    estaCargado: state.ventas.textoChequesEnCartera.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.chequesEnCartera
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: (idEmpresa) => dispatch(actions.loadTextoChequesEnCartera(idEmpresa)),
    onUnmountChart: () => dispatch(actions.clearTextoChequesEnCartera()),
    onShowGlobalModal: (title, content) => dispatch(actions.showGlobalModal(true, title, content, ''))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoChequesEnCartera);
